import { z } from 'zod'

import { imageSchema } from './image'
import { listQueryZodFields } from './system'
import { dbEntitySchema } from './system'

export const citySchema = dbEntitySchema.extend({
  name: z.string(),
  slugName: z.string(),
  state: z.string(),
  displayName: z.string().nullish(),
  shortName: z.string().nullish(),
  timezone: z.string().nullish(),
  enable: z.boolean().nullish(),
  images: z.array(imageSchema).nullish(),
  location: z.array(z.number()).nullish(),
  neighborhoods: z.array(z.string().or(z.null())).nullish(),
  venueCount: z.number().int().nonnegative().optional(),
  activeVenueCount: z.number().int().nonnegative().optional(),
})

const queryBoolean = z.preprocess((value) => {
  if (value === true || value === 'true' || value === '1') return true
  if (value === false || value === 'false' || value === '0') return false
  if (value === '' || value == null) return undefined
  return value
}, z.boolean().optional())

export const citiesListArgsSchema = z.object({
  ...listQueryZodFields,
  search: z.string().nullish(),
  enable: queryBoolean,
  noLimit: queryBoolean,
})

export const citiesListResponseSchema = z.object({
  data: z.array(citySchema),
  count: z.number(),
})

export const cityCreateSchema = citySchema.omit({
  id: true,
  _id: true,
  created: true,
  modified: true,
  deleted: true,
  venueCount: true,
  activeVenueCount: true,
})

export const cityUpdateByIdSchema = citySchema.pick({
  name: true,
  displayName: true,
  slugName: true,
  enable: true,
  timezone: true,
  state: true,
  images: true,
})

export const cityUpdateByIdArgsSchema = cityUpdateByIdSchema.partial()
